module.exports = __webpack_public_path__ + "static/media/credit10.31e3cd0b.png";